import { CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatFooterCell,
  MatFooterCellDef,
  MatFooterRow,
  MatFooterRowDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { PayrollMileageTripDTO } from 'src/app/models/payroll-mileage-trip.dto';
import { PayrollMileageTripsResponseDTO } from 'src/app/models/payroll-mileage-trips-response.dto';
import { ApiService } from 'src/app/services';

export interface PayrollsMileageDialogData {
  title: string;
  payroll_id: number;
}

@Component({
  selector: 'app-payrolls-mileage-dialog',
  templateUrl: './payrolls-mileage-dialog.component.html',
  styleUrls: ['./payrolls-mileage-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatProgressSpinner,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
  ],
})
export class PayrollsMileageDialogComponent implements OnInit {
  private readonly api = inject(ApiService);
  readonly data = inject<PayrollsMileageDialogData>(MAT_DIALOG_DATA);

  readonly displayed_columns = ['from_date', 'route', 'trip_distance_km', 'fuel_cost'];

  loading = true;
  response: PayrollMileageTripsResponseDTO | null = null;

  ngOnInit(): void {
    this.api.getPayrollMileageTrips(this.data.payroll_id).subscribe({
      next: (response: PayrollMileageTripsResponseDTO): void => {
        this.response = response;
        this.loading = false;
      },
      error: (): void => {
        this.loading = false;
      },
    });
  }

  routeLabel(trip: PayrollMileageTripDTO): string {
    const origin = trip.origin_location?.name ?? '—';
    const destination = trip.destination_location?.name ?? '—';

    return `${origin} → ${destination}`;
  }
}
